import { render, staticRenderFns } from "./ContractsRenewalList.vue?vue&type=template&id=3b09c50c&scoped=true"
import script from "./ContractsRenewalList.vue?vue&type=script&lang=js"
export * from "./ContractsRenewalList.vue?vue&type=script&lang=js"
import style0 from "./ContractsRenewalList.vue?vue&type=style&index=0&id=3b09c50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b09c50c",
  null
  
)

export default component.exports